import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

import Thumbnail from '~/images/video-thumbnail.png';

import GuideLineSVG from '~/images/guide-line.svg?react';
import CheckSVG from '~/images/trial-perk-check.svg?react';
import FreeSVG from '~/images/trial-perk-free.svg?react';
import LockSVG from '~/images/trial-perk-lock.svg?react';

export const PerkContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PerkText = styled.p`
  margin: 0;
`;

export const PerksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TrialCheckIcon = styled(CheckSVG)`
  display: block;
  flex: 1 0 60px;
`;

export const TrialLockIcon = styled(LockSVG)`
  display: block;
  flex: 1 0 60px;
`;

export const TrialFreeIcon = styled(FreeSVG)`
  display: block;
  flex: 1 0 60px;
`;

export const Title = styled.p`
  font-size: 32px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.normal};
`;

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 170px;
`;

export const LeftSection = styled.div`
  max-width: 314px;
`;

export const VideoGuide = styled.p`
  margin: 32px 0 42px;
  position: relative;
`;

export const VideoGuideLine = styled(GuideLineSVG)`
  position: absolute;
  top: 1px;
  right: -120px;
  pointer-events: none;
`;

export const VideoContainer = styled.div`
  position: relative;
  width: 675px;
  height: 380px;
  border-radius: 20px;
  overflow: hidden;
`;

export const PlayIndicator = styled.div<{ ready?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.background.surface};
  border-radius: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 118px;
  height: 38px;
  border: none;
  outline: none;
  box-shadow:
    0px 24px 123px 0px rgba(9, 3, 22, 0.35),
    0px 7px 32px 0px rgba(9, 3, 22, 0.18),
    0px 3px 15px 0px rgba(9, 3, 22, 0.1),
    0px 1px 5px 0px rgba(9, 3, 22, 0.03);
  opacity: ${({ ready }) => (ready ? 1 : 0.5)};
  z-index: 100;
  transition: all 0.2s ease-in-out;
`;

export const PlayButton = styled.button`
  position: absolute;
  border: none;
  inset: 0;
  cursor: pointer;

  &:active,
  &:focus {
    outline: none;
  }

  &:hover ${PlayIndicator} {
    background: ${({ theme }) => theme.colors.border.semi};
  }
`;

export const PlayIcon = styled(Icon).attrs({
  name: 'play',
})`
  color: ${({ theme }) => theme.colors.primary};
  height: 32px;
  width: 32px;
  margin-left: -6px;
`;

export const PlayLabel = styled.span`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 3px;
  margin-left: 6px;
`;

export const VideoThumbnail = styled.img.attrs({
  src: Thumbnail,
})`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 50;
`;

export const Video = styled.iframe.attrs({
  height: '100%',
  width: '100%',
  title: 'BugBug 2-minute demo overview',
  allowFullScreen: true,
  frameBorder: '0',
  allow: 'autoplay; fullscreen; picture-in-picture',
})`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  aspect-ratio: 16 / 9;
`;
